import { AllContentKey } from "./keys";

// Helper to check if arr1 contains all elements of arr2 (assuming both sorted)
function hasSubArray(arr1: any[], arr2: any[]): boolean {
  return arr2.every(val => arr1.includes(val));
}

export function filterByKeys<T extends Record<string, any>>(res: T[], filter: Partial<Record<AllContentKey, string[] | string>>) {
  for (const key of Object.keys(filter) as AllContentKey[]) {
    const filterValue  = filter[key];
    if (!filterValue || (Array.isArray(filterValue) && filterValue.length === 0)) {
      continue; // skip empty filters
    }

    if ([
      'glycemicIndexRange', 'glycemicLoadRange', 'timePreparation', 'category', 'durationInWeeks'
    ].includes(key)) {
      res = res.filter(item => {
        if (Array.isArray(filterValue)) {
          return filterValue.includes(item[key]);
        }
        return false;
      });
    } else if (key === 'difficultyLevel') {
      if (!Array.isArray(filterValue)) {
        continue;
      }
      res = res.filter(item => {
        // item.difficultyLevel might be scalar or array, convert to string for comparison
        const itemDifficulty = item.difficultyLevel;
        if (Array.isArray(itemDifficulty)) {
          return itemDifficulty.some(level => filterValue.includes(String(level)));
        } else {
          return filterValue.includes(String(itemDifficulty));
        }
      });
    } else if (key === 'muscleRegime') {
      // muscleRegime is a single string in filter (array with one string)
      if (Array.isArray(filterValue)) {
        res = res.filter(item => item.muscleRegime === filterValue[0]);
      }
    } else if (key === 'sports') {
      // sports is an array; we want to check if item.sports contains all filter.sports elements
      if (Array.isArray(filterValue)) {
        res = res.filter(item => {
          if (!Array.isArray(item.sports)) return false;
          return hasSubArray(item.sports.slice().sort(), filterValue.slice().sort());
        });
      }
    } else {
      // Generic case: most fields are arrays, check if item[key] array contains filter[key] array elements
      if (Array.isArray(filterValue)) {
        res = res.filter(item => {
          const itemVal = item[key];
          if (!Array.isArray(itemVal)) return false;
          return hasSubArray(itemVal.slice().sort(), filterValue.slice().sort());
        });
      } else {
        // If filterValue is string (not array), strict equality check
        res = res.filter(item => item[key] === filterValue);
      }
    }
  }
  return res;
}
